import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptOise60 = () => {
  return (
    <DepartmentTemplate
      department="Oise"
      departmentNumber="60"
      cities="Beauvais, Compiègne, Creil, Senlis"
      region="Hauts-de-France"
    />
  );
};

export default DeptOise60;
